function notEmptyNode(value) {
    return null != value;
}
const src_notEmptyNode = notEmptyNode;
export default src_notEmptyNode;
